export default [
  {
    path: '/admin/config/smtp',
    name: 'Smtp',
    component: () => import('@/views/Admin/Smtp/Index.vue'),
    meta: {
      pageTitle: 'Ayarlar',
      breadcrumb: [
        {
          text: 'SMTP Yapılandırma',
          active: true,
        },
      ],
      resource: 'ADMIN_SMTP_CONFIG',
      action: 'read',
    },
  },
  {
    path: '/admin/config/company',
    name: 'ConfigCompany',
    component: () => import('@/views/Admin/Config_company/Index.vue'),
    meta: {
      pageTitle: 'Ayarlar',
      breadcrumb: [
        {
          text: 'Firma Listesi',
          active: true,
        },
      ],
      resource: 'ADMIN_COMPANY_CONFIG',
      action: 'read',
    },
  },
  {
    path: '/admin/config/company/add',
    name: 'ConfigCompany',
    component: () => import('@/views/Admin/Config_company/Add.vue'),
    meta: {
      pageTitle: 'Ayarlar',
      breadcrumb: [
        {
          to: '/admin/config/company',
          text: 'Firma Listesi',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_COMPANY_CONFIG',
      action: 'read',
    },
  },
  {
    path: '/admin/config/company/edit/:id',
    name: 'ConfigCompany',
    component: () => import('@/views/Admin/Config_company/Edit.vue'),
    meta: {
      pageTitle: 'Ayarlar',
      breadcrumb: [
        {
          to: '/admin/config/company',
          text: 'Firma Listesi',
          active: false,
        },
        {
          text: 'Düzenle',
          active: true,
        },
      ],
      resource: 'ADMIN_COMPANY_CONFIG',
      action: 'read',
    },
  },
]
